import React from 'react';
import { useCart } from '../context/CartContext';
import MobileCartNotification from './MobileCartNotification';
import MobileCartDrawer from './MobileCartDrawer';

const CartNotificationWrapper: React.FC = () => {
  const { 
    isMobileNotificationVisible, 
    hideMobileNotification,
    isMobileCartDrawerOpen,
    hideMobileCartDrawer
  } = useCart();

  return (
    <>
      <MobileCartNotification
        isVisible={isMobileNotificationVisible}
        onClose={hideMobileNotification}
      />
      <MobileCartDrawer
        isOpen={isMobileCartDrawerOpen}
        onClose={hideMobileCartDrawer}
      />
    </>
  );
};

export default CartNotificationWrapper;
